import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";
import { api } from "api";

const LISTADO_AGENTE = 'LISTADO_AGENTE';
const LOADER = 'LOADER';
const MODULO = 'MODULO';

const setLoader = loader => ({
    type: LOADER,
    loader,
});

export const listar = () => (dispatch) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    let id = id_emp[5];
    let params = { id };
    dispatch(setLoader(true));
    api.get('/registro_marca/agente', params).then((response)=>{
        dispatch({ type: LISTADO_AGENTE, data: response });
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al listar agentes',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const registroAgente = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const data = getStore().form.FormAgenteRM.values;
    let id_empresa = id_emp[5]

    const formData = {
        nombre_agente: data.nombre_agente,
        empresa: id_empresa
    }
    dispatch(setLoader(true));
    api.post('/registro_marca/agente/', formData).then(() => {
        NotificationManager.success(
            'Agente creado',
            'Exito',
            3000
        );
        let ruta = '';
        ruta = `/registro_marca/${id_emp[5]}/agente`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            error.msj,
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

export const modificarAgente = () => (dispatch, getStore) => {
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    const datos = getStore().form.FormAgenteRM.values;
    const id = datos.id;
    const formData = {
        id: id,
        nombre_agente: datos.nombre_agente,
    }
    dispatch(setLoader(true));
    api.put(`/registro_marca/agente/${id}/`, formData).then(() => {
        NotificationManager.success(
            'Agente modificado correctamente',
            'Exito',
            3000
        );
        let ruta = `/registro_marca/${id_emp[5]}/agente`
        dispatch(push(ruta));
    }).catch((error) => {
        NotificationManager.error(
            'Ocurrió un error al modificar agente',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`/registro_marca/agente/${id}`).then((response) => {
        dispatch(initializeForm('FormAgenteRM', response ));
    }).catch((error)=>{
        NotificationManager.error(
            'Ocurrió un error al consultar agente',
            'Error',
            2000
        );
    }).finally(() => {
        dispatch(setLoader(false));
    });

}

export const getModulo = (id, modulo) => (dispatch) => {
    const params = {id, modulo}
    dispatch(setLoader(true));
    api.get('/modulos/modulo/', params).then((response)=>{
        dispatch({ type: MODULO, modulo: response.modulos });
    }).catch(() => {
        if (error.status === 401){
            NotificationManager.error(
              error.body.msj,
              'Error',
              0
            );
        }
        if (error.status === 400){
            NotificationManager.error(
              'Ocurrió un error en buscar modulo',
              'Error',
              0
            );
        }
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

export const actions = {
    listar,
    registroAgente,
    modificarAgente,
    leer,
    getModulo,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LISTADO_AGENTE]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [MODULO]: (state, { modulo }) => {
        return {
            ...state,
            modulo,
        };
    },
};

export const initialState = {
    loader: false,
    modulo: [],
    data: [],
    listaPais: [],
    detallePais: [],
};

export default handleActions(reducers, initialState)
 